import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { canonicalUrl } from "../utility/siteUrl";

// Emits a self-referencing canonical URL for every route so the canonical
// host (www) is baked into prerendered HTML.
const Seo = () => {
  const { pathname } = useLocation();
  const url = canonicalUrl(pathname);

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Create Prints" />
      <meta property="og:type" content="website" />
      <meta
        property="og:image"
        content="https://www.createprints.ai/create-prints-hero-768.webp"
      />
      <meta
        property="og:image:alt"
        content="Create Prints wall art displayed in an interior"
      />
    </Helmet>
  );
};

export default Seo;
